export type TokenAction = 'insert' | 'update' | 'delete'

export const TOKEN_ACTION_LABELS: Record<TokenAction, string> = {
  insert: 'Insert Token',
  update: 'Update Token',
  delete: 'Delete Token',
}

export const TOKEN_ACTION_DESCRIPTIONS: Record<TokenAction, string> = {
  insert: 'Add a new token configuration',
  update: 'Update token metadata',
  delete: 'Remove an existing token configuration',
}
